import React from "react"
import Container from "./container"
import Header from "./header"

type RootWrapperProps = {
  children: React.ReactNode
}

const RootWrapper: React.FC<RootWrapperProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background-primary text-foreground-primary">
      <Container>
        <Header />
        {children}
      </Container>
    </div>
  )
}

export default RootWrapper
